import React, { useState } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { Button, Modal } from "components"
import { isSimpleFood } from "utils"
import FoodModalDoneButton from "./FoodModalDoneButton"
import FoodModalHeader from "./FoodModalHeader"
import FoodModalRightSide from "./FoodModalRightSide"
import FoodModalSpecifications from "./FoodModalSpecifications"
import FoodModalOptions from "./FoodModalOptions"
import classes from "./index.module.scss"
import clsx from "clsx"

const getFirstInStockOption = (food) => (
  food.options.find(option =>
    option.isAvailable
      ?
      option.outOfStock
        ?
        false
        :
        option.stockManagement
          ? option.availableQuantity > 0
          : true
      :
      false
  )
)

const FoodModal = props => {
  const {
    food,
    openModal,
    setOpenModal,
    onExited = () => { },
    initialValues
  } = props

  const [t, i18n] = useTranslation()

  const foodSpecificationsMap =
    useSelector(state => state.foodSpecificationsMap)

  const firstInStockOption =
    getFirstInStockOption(food)

  const initialFormSalePrice =
    firstInStockOption?.salePrice || 0

  const initialFormState = {
    quantity: 1,
    discount: 0,
    reduction: 0,
    salePrice: initialFormSalePrice,
    optionId: firstInStockOption?._id || "",
    specificationItems: []
  }

  const [form, setForm] = useState(initialFormState)
  const [focuedInputName, setFocuedInputName] = useState("quantity")

  const handleExited = () => {
    onExited()

    setForm({
      quantity: 1,
      discount: 0,
      reduction: 0,
      salePrice: initialFormSalePrice,
      optionId: firstInStockOption?._id,
      specificationItems: []
    })
  }

  const fillForm = () => {
    const editMode = !!initialValues

    if (!editMode) return

    setForm({ ...initialValues })
  }

  const getFoodSpecifications = () => {
    const foodSpecifications = []

    food.specificationIds.forEach((specificationId) => {
      const specifcation =
        foodSpecificationsMap[specificationId]

      if (!specifcation) return

      foodSpecifications.push(specifcation)
    })

    return foodSpecifications
  }

  const simpleFood = isSimpleFood(food.options)

  const limitModalWidth =
    simpleFood &&
    food.options.length === 1 &&
    food.specificationIds.length === 0

  const foodSpecifications =
    getFoodSpecifications()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Modal
      size="lg"
      backdrop="static"
      show={openModal}
      onEnter={fillForm}
      onExited={handleExited}
    >
      <div className={classes["container"]}>
        <FoodModalHeader
          food={food}
          optionId={form.optionId}
          reduction={form.reduction}
          specificationItems={form.specificationItems}
        />

        <div className={classes["main"]}>
          {
            !limitModalWidth &&
            <div className={classes["left"]}>
              <div className={classes["scroll"]}>
                <div className={classes["right"]}>
                  <FoodModalSpecifications
                    form={form}
                    setForm={setForm}
                    options={food.options}
                  />

                  <FoodModalOptions
                    form={form}
                    setForm={setForm}
                    specifications={foodSpecifications}
                    customBuilder={food.customBuilder}
                  />
                </div>
              </div>
            </div>
          }

          <FoodModalRightSide
            food={food}
            form={form}
            setForm={setForm}
            focuedInputName={focuedInputName}
            setFocuedInputName={setFocuedInputName}
          />
        </div>

        <div className={classes["footer"]}>
          <Button
            color="danger"
            onClick={() => setOpenModal(false)}
            className={clsx(classes["button"], isLtr && classes["button-ltr"])}
          >
            {t("انصراف")}
          </Button>

          <FoodModalDoneButton
            food={food}
            form={form}
            simpleFood={simpleFood}
            setOpenModal={setOpenModal}
            initialValues={initialValues}
          />
        </div>
      </div>
    </Modal>
  )
}

export default React.memo(FoodModal)
